import { useId } from "react";

export const FacebookIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#1877F2" />
    <path fill="#fff" d="M13.4 20v-6.9h2.3l.35-2.7H13.4V8.7c0-.78.22-1.31 1.34-1.31h1.42V5c-.25-.03-1.09-.1-2.07-.1-2.05 0-3.45 1.25-3.45 3.55v1.95H8.33v2.7h2.31V20h2.76z" />
  </svg>
);

export const InstagramIcon = ({ size = 18, className = "" }) => {
  const gid = useId();
  return (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <defs>
      <radialGradient id={gid} cx="30%" cy="107%" r="150%">
        <stop offset="0" stopColor="#FDF497" /><stop offset="0.05" stopColor="#FDF497" /><stop offset="0.45" stopColor="#FD5949" /><stop offset="0.6" stopColor="#D6249F" /><stop offset="0.9" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect x="1" y="1" width="22" height="22" rx="6.5" fill={`url(#${gid})`} />
    <rect x="5.2" y="5.2" width="13.6" height="13.6" rx="4" fill="none" stroke="#fff" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="3.3" fill="none" stroke="#fff" strokeWidth="1.8" />
    <circle cx="16.4" cy="7.6" r="1" fill="#fff" />
  </svg>
  );
};

export const LinkedinIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <rect x="1" y="1" width="22" height="22" rx="4" fill="#0A66C2" />
    <path fill="#fff" d="M6.2 9.6h2.7V18H6.2V9.6zM7.55 5.4a1.57 1.57 0 1 1 0 3.14 1.57 1.57 0 0 1 0-3.14zM10.6 9.6h2.6v1.15h.04c.36-.68 1.24-1.4 2.56-1.4 2.74 0 3.25 1.8 3.25 4.15V18h-2.7v-4c0-.95-.02-2.18-1.33-2.18-1.33 0-1.53 1.04-1.53 2.11V18h-2.7V9.6z" />
  </svg>
);
